export default __webpack_public_path__ + "static/media/lawn-doctors-step-3.927b3555.jpg";